export function normaliseAuPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('61')) return digits;
  if (digits.startsWith('0')) return `61${digits.slice(1)}`;
  return digits;
}

export function pickBestMessage(lead) {
  const approved = String(lead?.approvedMessage || '').trim();
  if (approved) return approved;
  const draft = String(lead?.draftMessages?.[0]?.messageBody || '').trim();
  if (draft) return draft;
  return '';
}

export function buildMailtoUrl(lead, message = '') {
  const lines = String(message || '').split('\n');
  const firstNonEmpty = lines.findIndex((l) => l.trim() !== '');
  const subject = firstNonEmpty >= 0 ? lines[firstNonEmpty].trim() : '';
  const body = firstNonEmpty >= 0
    ? lines.slice(firstNonEmpty + 1).join('\n').replace(/^\n+/, '')
    : '';
  const to = String(lead?.email || lead?.contactEnrichment?.emails?.[0] || '').trim();

  const parts = [];
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  if (body) parts.push(`body=${encodeURIComponent(body)}`);
  if (parts.length > 0) return `mailto:${to}?${parts.join('&')}`;
  return `mailto:${to}`;
}

export function buildWhatsappUrl(lead, message = '') {
  const rawPhone = String(lead?.phone || lead?.contactEnrichment?.mobiles?.[0] || '').trim();
  const phone = normaliseAuPhone(rawPhone);
  if (!phone) return null;
  const text = String(message || '').trim();
  if (!text) return `https://wa.me/${phone}`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export function buildSmsUrl(lead, message = '') {
  const rawPhone = String(lead?.phone || lead?.contactEnrichment?.mobiles?.[0] || '').trim();
  const phone = normaliseAuPhone(rawPhone);
  if (!phone) return null;
  const text = String(message || '').trim();
  if (!text) return `sms:${phone}`;
  return `sms:${phone}?body=${encodeURIComponent(text)}`;
}
